import { WishlistItemDto } from '../../../pages/wishlist/dto/wishlist.dto';

export function addToWishlistUtility(
  wishlist: WishlistItemDto[],
  item: WishlistItemDto
): WishlistItemDto[] {
  const exists = wishlist.some(
    w => w.product.id === item.product.id && w.variantSku === item.variantSku
  );
  if (exists) {
    return wishlist;
  }
  return [...wishlist, item];
}
